import React, { useRef } from "react";
import "date-fns";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import DateFnsUtils from "@date-io/date-fns";
import EditIconRounded from "@material-ui/icons/EditRounded";
import DeleteOtlined from "@material-ui/icons/DeleteRounded";
import { useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../../context/AuthContex";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
const ModaluseStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 180,
  },
  formControlLabel: {
    marginTop: theme.spacing(1),
  },
}));

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

function createData(
  _id,
  no_ordem,
  treiceros,
  lado_ordem,
  quantidade_negocio,
  preco_negocio,
  hora_negocio,
  tipo_negocio
) {
  return {
    _id,
    no_ordem,
    treiceros,
    lado_ordem,
    quantidade_negocio,
    preco_negocio,
    hora_negocio,
    tipo_negocio,
  };
}

const rows = [];

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
});

const useBtnStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

export default function NegocioExecutado() {
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;
  const { user } = useContext(AuthContext);

  const [tableinformation, settableinformation] = useState([]);
  const [tableRows, settableRows] = useState([]);

  const [condicaoPreco, setCondicaoPreco] = React.useState("");
  const [condicaoTempora, setcondicaoTempora] = React.useState("");
  const handlecondicaoPreco = (event) => {
    setCondicaoPreco(event.target.value);
  };
  const handlecondicaoTemporal = (event) => {
    setcondicaoTempora(event.target.value);
  };

  const classes = useStyles();
  const classButton = useBtnStyles();

  const modelClass = ModaluseStyles();

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (row) => {
    settableinformation(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const userentrytotal = useRef();
  const userentrymin = useRef();
  const userentryprecolimite = useRef();
  const userentryprecodesparo = useRef();
  const userentrycondicao = useRef();
  const userentrytemporal = useRef();
  const userentrydatechosen = useRef();
  const manageComprar = () => {
    console.log(
      userentrytotal.current.value +
        userentrymin.current.value +
        userentryprecolimite.current.value +
        userentryprecodesparo.current.value +
        userentrycondicao.current.value +
        userentrytemporal.current.value
    );
  };

  const [selectedDate, setSelectedDate] = React.useState(
    new Date("2014-08-18T21:11:54")
  );

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  //   useEffect(() => {
  //     const buscarOrdens = async () => {
  //       try {
  //         const res = await axios.get(PF + "../ordem/usuario/" + user._id);
  //         settableRows(res.data);
  //       } catch (err) {
  //         console.log(err);
  //       }
  //     };
  //     buscarOrdens();
  //   }, []);

  //   tableRows.map((o) =>
  //     rows.push(
  //       createData(
  //         o._id,
  //         o.codigo_de_negociacao,
  //         o.quantidade_total,
  //         o.quantidade_minima,
  //         o.preco_limite,
  //         o.preco_dispario
  //       )
  //     )
  //   );

  return (
    <>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>Nº Ordem </StyledTableCell>
              <StyledTableCell align="right">Treiçeros</StyledTableCell>
              <StyledTableCell align="right">Lado da Ordem</StyledTableCell>
              <StyledTableCell align="right">
                Quantidade do Negócio
              </StyledTableCell>
              <StyledTableCell align="right">Preço do Negócio</StyledTableCell>
              <StyledTableCell align="right">
                Hora da Negócioção
              </StyledTableCell>
              <StyledTableCell align="right">Tipo do Negócio</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <StyledTableRow key={row._id}>
                <StyledTableCell component="th" scope="row">
                  {row.no_ordem}
                </StyledTableCell>
                <StyledTableCell align="right">{row.treiceros}</StyledTableCell>
                <StyledTableCell align="right">
                  {row.lado_ordem}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.quantidade_negocio}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.preco_negocio}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.hora_negocio}
                </StyledTableCell>
                <StyledTableCell align="right">
                  {row.tipo_negocio}
                </StyledTableCell>

                <StyledTableCell align="right">Pendente</StyledTableCell>
                <StyledTableCell align="right">
                  <IconButton
                    aria-label="accao"
                    className={classButton.margin}
                    onClick={() => handleClickOpen(row)}
                  >
                    <EditIconRounded />
                  </IconButton>
                </StyledTableCell>

                <StyledTableCell align="right">
                  <IconButton aria-label="accao" className={classButton.margin}>
                    <DeleteOtlined />
                  </IconButton>
                </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={open}
        onClose={handleClose}
        aria-labelledby="max-width-dialog-title"
      >
        <DialogTitle id="max-width-dialog-title">Actualizar Oferta</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Actualização da Janela de Ofertas
          </DialogContentText>
          <form className={modelClass.form} noValidate>
            <Grid container spacing={3}>
              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Codigo de negociacao "
                    defaultValue={tableinformation.codigo_de_negociacao}
                    InputProps={{
                      readOnly: true,
                    }}
                    variant="filled"
                  />
                </FormControl>
              </Grid>
            </Grid>

            <Grid container spacing={3} style={{ marginTop: "10px" }}>
              <Grid item xs={3}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Quantidade total"
                    inputRef={userentrytotal}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Quantidade minima"
                    inputRef={userentrymin}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={3}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Preço Limite"
                    inputRef={userentryprecolimite}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3}>
                <FormControl className={modelClass.formControl}>
                  <TextField
                    id="filled-read-only-input"
                    label="Preço Disparo"
                    inputRef={userentryprecodesparo}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <InputLabel id="condicaolabel">Condição do preço</InputLabel>
                  <Select
                    labelId="condicaolabel"
                    value={condicaoPreco}
                    onChange={handlecondicaoPreco}
                    id="condicao"
                    inputRef={userentrycondicao}
                  >
                    <MenuItem value={"Limitada"}>Limitada</MenuItem>
                    <MenuItem value={"Mercado"}>Mercado</MenuItem>
                    <MenuItem value={"Stop"}>Stop</MenuItem>
                    <MenuItem value={"Abertura"}>Abertura</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <FormControl className={modelClass.formControl}>
                  <InputLabel id="condicaoTemporalLabel">
                    Condição Temporal
                  </InputLabel>
                  <Select
                    labelId="condicaoTemporalLabel"
                    value={condicaoTempora}
                    onChange={handlecondicaoTemporal}
                    id="condicaoTempora"
                    inputRef={userentrytemporal}
                  >
                    DIA IOC GTC GTD
                    <MenuItem value={"DIA"}>DIA</MenuItem>
                    <MenuItem value={"IOC"}>IOC</MenuItem>
                    <MenuItem value={"GTC"}>GTC</MenuItem>
                    <MenuItem value={"GTD"}>GTD</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    inputRef={userentrydatechosen}
                    margin="normal"
                    id="date-picker-inline"
                    label="Data de Validade"
                    value={selectedDate}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </MuiPickersUtilsProvider>
              </Grid>

              <Grid item xs={4}>
                <Button
                  variant="contained"
                  onClick={manageComprar}
                  color="primary"
                >
                  Guardar
                </Button>
              </Grid>

              <Grid item xs={4}></Grid>

              <Grid item xs={4}>
                <Button variant="contained" color="secondary">
                  Eliminar
                </Button>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
